// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconSitemap, IconUsers, IconCertificate } from '@tabler/icons-react';

// constant
const icons = {
    IconSitemap,
    IconUsers,
    IconCertificate
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const security = {
    id: 'security-group',
    type: 'group',
    title: <FormattedMessage id="account" />,
    children: [
        {
            id: 'users',
            title: <FormattedMessage id="users" />,
            type: 'item',
            url: '/loolu/admin/users',
            icon: icons.IconUsers,
            external: false,
            breadcrumbs: false
        },
        {
            id: 'profiles',
            title: <FormattedMessage id="profiles" />,
            type: 'item',
            url: '/loolu/admin/profiles',
            icon: icons.IconSitemap,
            external: false,
            breadcrumbs: false
        },
        {
            id: 'config/guarantees',
            title: <FormattedMessage id="guarantees" />,
            type: 'item',
            url: '/loolu/admin/config/guarantees',
            icon: icons.IconCertificate,
            external: false,
            breadcrumbs: false
        }
    ]
};

export default security;
